import { styled } from 'styled-components'

// Keeps the badge on the same line as the title's last word
export const NoWrap = styled.span`
  white-space: nowrap;
`
